import { ChartModel } from './chart-model';

export class ProgramArticleStats {
    destination: string;
    charts: ChartModel[] = [];

    /**
     * Default Constructor
     */
    constructor() {        
    }
}


// WEBPACK FOOTER //
// ./src/app/models/program-article-stats.ts